export const loginCookie = {
  client: 'PHPSESSID',
  admin: 'c'
}
